const modelName = 'Mailchimp';
const modelNameSingular = 'Mailchimp';
const endpoint = '/mailchimp';

const setup = {
    title: modelName,
    singular: modelNameSingular,
    model: modelName.replace(/\s+/g, '-').toLowerCase(),
    canDelete: false,
    canAddNew: false,
    canSearch: false,
    canSelect: false,
    endpoint,
    accessor: 'id',
};

export default setup;
